























import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
/**
 * 2023.10.20 [2023L-04] add
 */
@Component
export default class VariableScreenOfMultiFile extends Vue {
  @Prop() private variableList!: any;
}
